
<div class="drd-container col-12" [hidden]="!commonService.getIsLockedEnterprise()">
  {{ "enterprise_contract.panel_document.lb_create_document_is_locked_1" | translate }}
  <br style="margin: 8px;"/>
  {{ "enterprise_contract.panel_document.lb_create_document_is_locked_2" | translate }}
</div>
  <div class="row" style="padding: 0; background-color: white; margin: 0;" [hidden]="commonService.getIsLockedEnterprise()">
      <!-- Infomation -->
      <div [hidden]="tabMode === 'hide'" class="col-lg-5 col-md-12 col-sm-12 pr-0" style="height: calc(91vh - 140px); overflow: auto;">
          <div class="col-12 text-title">
              <mat-label>{{'title.resources_used' | translate}} {{convertTitleResource()}}</mat-label>
          </div>
          <!-- Thông tin hợp đồng  -->
          <mat-expansion-panel [expanded]="true" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <!-- Thông tin liên hệ -->
              <mat-panel-title class="mat-panel-title justify-content-between">
                <span>{{'title.document_info' | translate}}</span>
                <small class="form-text text-gray pull-left">(<span style="color: red;">*</span>) {{'form.info' |
                  translate}}
                </small>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form #f="ngForm"
              (ngSubmit)="(!f.form.valid ? onValidateGeneralInfo() : 'true') && f.form.valid  &&  onSubmit($event)" #pannelForm
              appFocusFirstElement class="w-100">
            <div class="row">
              <!-- Tên HĐ -->
              <div class="col-12" style="padding: 0 12px;">
                <mat-form-field class="w-100" style="width: -webkit-calc(100% - 35px) !important;
                                                    width: -moz-calc(100% - 35px) !important;
                                                    width: calc(100% - 35px) !important;">
                  <input (focusout)="document.name = document.name.trim(); setFormChanging()" matInput
                        placeholder="{{'form.doc_name' | translate}}" autocomplete="off" type="text" name="documentName"
                        #documentName="ngModel" [(ngModel)]="document.name" required
                        [ngClass]="{ 'is-invalid': f.submitted || documentName.invalid }" maxlength="100"
                  />
                  <button mat-button *ngIf="document.name" type="button" matSuffix mat-icon-button aria-label="Clear"
                          (click)="document.name=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="f.submitted || documentName.invalid">
                            <span *ngIf="documentName?.errors?.required" class="text-error">
                              {{'validation.document_type_name' | translate}}
                            </span>
                  </mat-error>
                </mat-form-field>
                <mat-icon matSuffix
                          matTooltip="{{'enterprise_contract.panel_document.help_document_name.tooltip' | translate}}"
                          class="custom-position-for-icon"
                          (click)="createTplModal(tplHelpTitle, tplHelpContent, tplHelpFooter)">help_outline
                </mat-icon>
                <ng-template #tplHelpTitle>
                  <span>{{'enterprise_contract.panel_document.help_document_name.modal_title' | translate}}</span>
                </ng-template>
                <ng-template #tplHelpContent>
                  <p>{{'enterprise_contract.panel_document.help_document_name.modal_content1' | translate}}</p>
                  <p>{{'enterprise_contract.panel_document.help_document_name.modal_content2' | translate}}
                    <b>{{'enterprise_contract.panel_document.help_document_name.modal_content3' | translate}}</b>
                    {{'enterprise_contract.panel_document.help_document_name.modal_content4' | translate}}
                  </p>
                </ng-template>
                <ng-template #tplHelpFooter>
                  <button nz-button nzType="primary" (click)="destroyTplModal()">
                    {{'button.close' | translate}}
                  </button>
                </ng-template>
              </div>
              <!-- Mã HĐ -->
              <div class="col-12" style="padding: 0 12px;" 
              style="width: -webkit-calc(100% - 35px) !important;
              width: -moz-calc(100% - 35px) !important;
              width: calc(100% - 35px) !important;">
                <mat-form-field class="w-100">
                  <input (focusout)="document.code = document.code.trim(); setFormChanging()" matInput
                         placeholder="{{'form.doc_code' | translate}}" autocomplete="off" type="text" name="code"
                         #code="ngModel" [(ngModel)]="document.code" [pattern]="documentCodePattern"
                         [ngClass]="{ 'is-invalid': f.submitted || code.invalid }" required maxlength="50" id="code"
                         [disabled]="warningContractQuantity || isOnAutoNumber"/>
                  <button mat-button *ngIf="document.code && !isOnAutoNumber" type="button" matSuffix mat-icon-button aria-label="Clear"
                          (click)="document.code=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="(f.submitted || code.invalid) && !isOnAutoNumber">
                            <span *ngIf="code?.errors?.required" class="text-error">
                              {{'validation.document_type_code' | translate}}
                            </span>
                    <span *ngIf="code?.errors?.pattern" class="text-error">
                              {{'validation.lbl_validation_document_code_format' | translate}}
                            </span>
                    <span class="text-error" *ngIf="code?.errors?.duplicate">
                              {{'validation.document_code_duplicate' | translate}}
                            </span>
                  </mat-error>
                </mat-form-field>
                <div *ngIf="isOnAutoNumber" class="w-100 pb-2" style="font-style: italic; transform: translateY(-10px) !important;">
                  <span><strong>{{'service_type.remind_configuration.note' | translate}}</strong>
                    <span>{{'validation.note_contracts_documents_auto' | translate}}&nbsp;</span>
                  </span>
                </div>
              </div>
              <!-- Loại HĐ -->
              <div class="col-12" style="padding: 0 12px;">
                <mat-form-field 
                  class="w-100"
                  [class.input-document]="isShowAddDocument"
                  [class.input-document-no]="!isShowAddDocument"
                  style="
                    width: -webkit-calc(100% - 35px) !important;
                    width: -moz-calc(100% - 35px) !important;
                    width: calc(100% - 35px) !important;"
                >
                  <mat-label>{{'enterprise_document_template_add_pop.cbx_service_type.lbl_service_type' | translate}}
                  </mat-label>
                  <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)"
                              (selectionChange)="selectedChange($event)"
                              (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceTypeId"
                              name="serviceTypeId" [(ngModel)]="document.serviceType" #serviceTypeId="ngModel" required
                              [disabled]="warningContractQuantity">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                                            [placeholderLabel]="'search_form.search' | translate"
                                            [formControl]="serviceTypesFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                                (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                      {{serviceType.name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="f.submitted || serviceTypeId.invalid || serviceTypeId.errors?.required">
                    {{'validation.service_type' | translate}}
                  </mat-error>
                </mat-form-field>
                <ng-container *ngIf="isShowAddDocument">
                  <mat-icon
                    matSuffix
                    matTooltip="{{'enterprise_contract.panel_document.help_document_name.tooltip' | translate}}"
                    class="custom-position-for-icon"
                    style="cursor: pointer;"
                    (click) = "openDialogAdd()"
                  >add_circle_outline
                  </mat-icon>
                </ng-container>

              </div>
            </div>
            </form>
          </mat-expansion-panel>
          <!-- Thông tin bên ký  -->
          <mat-expansion-panel expanded="true" class="mat-elevation-z0 info-signer">
            <mat-expansion-panel-header>
              <mat-panel-description class="mat-panel-title">
                  <div class="title-contract-party">
                    <div class="title">
                      {{ "form.contracting_parties" | translate }}
                      <mat-icon class="mr-0 text-primary" style="font-size: x-large; cursor: pointer; margin-left: 8px;"
                                matTooltip="{{ 'procedure.choose_procedure_full' | translate }}" (click)="openDialogProcedure(1, $event)">
                        add_circle_outline
                      </mat-icon>
                    </div>
                    <div class="note" *ngIf="selectedServiceType?.internalFlowNotEdit">{{ "form.note_contracting_parties" | translate }}</div>
                  </div>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="row" style="background: #fafafa;">
              <div class="col-2 head-table border-top-left" style="color: #ee0033;">
                {{
                  "enterprise_contract.panel_document.table_parties.header.order"
                    | translate
                }}
              </div>
              <div class="col-9 head-table border-top-left" style="color: #ee0033;">
                {{
                  "enterprise_contract.panel_document.table_parties.header.party_name"
                    | translate
                }}
              </div>
              <div class="head-table col-1 border-top-right-left">
              </div>
            </div>
            <!-- Danh sách công ty -->
            <!-- Nếu là công ty lập  -->
            <div *ngFor="let enterprise of enterpriseSign; let i = index" class="">
              <ng-container *ngIf="enterprise.isCreatedSide">
                <div class="row">
                  <div class="col-2 head-table border-top-left">
                    <nz-input-number class="td-nz-input" [(ngModel)]="enterprise.order" [nzMin]="1"
                      [ngModelOptions]="{ standalone: true }">
                    </nz-input-number>
                  </div>
                  <div class="col-9 head-table name-left border-top-left">
                    {{ enterprise.name }}
                  </div>
                  <div class="head-table col-1 border-top-right-left">
                    <div class="d-flex justify-content-center">
                      <a class="text-center" nz-popconfirm nzPopconfirmTitle="{{
                          'popup.confirm_delete_party' | translate
                        }}" (nzOnConfirm)="
                          deleteEnterprise(enterprise, true, i)
                        " [nzIcon]="iconDel" nzCancelText="{{ 'button.cancel' | translate }}"
                         nzOkText="{{ 'button.ok' | translate }}">
                        <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                      </a>
                      <ng-template #iconDel>
                        <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                      </ng-template>
        
                      <a (click)="isShowUserSignTable = !isShowUserSignTable"
                         style="transition: 0.3s; margin-left: 7px; display: flex; align-items: center;"
                         [ngStyle]="{'transform': !isShowUserSignTable ? 'rotate(0deg)' : 'rotate(180deg)'}">
                        <i class="fa fa-angle-down" aria-hidden="true" nzIcon style="font-size: 17px;"
                           matTooltip="{{ (isShowUserSignTable ? 'tooltips.hidden' : 'tooltips.show') | translate }}"></i>
                      </a>
                    </div>
                  </div>
                </div>
                
                <div class="row" *ngIf="isShowUserSignTable">
                  <div class="col-2 border-top-left"></div>
                  <div class="col-10 p-0">
                    <!-- Thêm luồng ký nôi bộ  -->
                    <div class="col-12 p-table-base border-top-right-left">
                      <div class="font-color-blue" style="display: flex; font-weight: 600;">
                        {{ "form.order_of_approval_signing_contract_unit" | translate }} &nbsp;
                        <div class="d-flex">
                          <mat-icon class="mr-0 text-primary" style=" font-size: x-large; cursor: pointer"
                                    matTooltip="{{ 'procedure.choose_procedure_private' | translate }}"
                                    (click)="openDialogProcedure(2, $event)">add_circle_outline
                          </mat-icon>
                        </div>
                      </div>
                    </div>
                    <!-- Danh sách phê duyệt  -->
                    <div class="col-12 row" style="padding: 0; margin: 0; background: #fafafa;">
                      <div class="head-table border-top-left" style="width: 20%; color: #ee0033;">
                        {{
                          "enterprise_contract.panel_document.table_users.header.order"
                            | translate
                        }}
                      </div>
                      <div class="head-table border-top-left" style="width: 70%; color: #ee0033;">
                        {{
                          "enterprise_contract.panel_document.table_users.header.name"
                            | translate
                        }}
                      </div>
                      <div class="head-table border-top-right-left" style="width: 10%;">
                      </div>
                    </div>
                    <div class="col-12 p-table-base font-color-blue border-top-right-left">
                      {{ "form.contract_approver" | translate}} &nbsp;
                    </div>
                    <div *ngFor="let user of userSigns; let j = index" class="row" style="margin: 0;">
                      <ng-container *ngIf="user.role == '2'">
                        <div class="head-table border-top-left" style="width: 20%;">
                          <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit; else isFlowNotEdit">
                            <div class="d-flex justify-content-center">
                              {{user.order}}
                            </div>
                          </ng-container>
                          <ng-template #isFlowNotEdit>
                            <nz-input-number class="td-nz-input" [(ngModel)]="user.order" [nzMin]="1"
                            [ngModelOptions]="{ standalone: true }"></nz-input-number>
                          </ng-template>
                        </div>
                        <div class="head-table name-left border-top-left" style="width: 70%;">
                          <div class="editable-cell" *ngIf="user.userId != null">
                            <div *ngIf="user.departmentName" class="row-icon department"><span
                              class="material-icons">apartment</span>{{ user.departmentName }}</div>
                            <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                              {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                          </div>
                        </div>
                        <div class="head-table border-top-right-left" style="width: 10%;">
                          <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                            <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                                'popup.confirm_delete_user' | translate
                              }}" (nzOnConfirm)="deleteUser(user)"
                              nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                              <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                            </a>
                            <ng-template #iconDel>
                              <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                            </ng-template>
                          </ng-container>
                          <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
                            <a *ngIf="user.userId != null"
                            >
                              <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                            </a>
                          </ng-container>
                        </div>
                      </ng-container>
                    </div>
                    
                    <!-- Tìm kiếm danh sách phê duyệt  -->
                    <div class="row" style="margin: 0;">
                      <div class="head-table border-top-left" style="width: 20%;">
                      </div>
                      <div class="head-table border-top-left" style="width: 70%;">
                        <div style="width: 100%;">
                          <nz-input-group [nzSuffix]="suffixUserInput">
                            <input [disabled]="warningContractQuantity || selectedServiceType?.internalFlowNotEdit" nz-input [(ngModel)]="inputUserValue"
                                   (input)="onChangeUserSignSearch($event)" [nzAutocomplete]="autoUserSearching"
                                   [ngModelOptions]="{ standalone: true }"
                                   placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" #autocompleteInput
                                   id="inputUser" />
                            <nz-autocomplete #autoUserSearching>
                              <nz-auto-option *ngFor="let user of filteredUserOptions"
                                              (selectionChange)="autocompleteUserSelected($event, user)" [nzValue]="''">
                                <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department"><span
                                  class="material-icons">apartment</span>{{ user.departmentName }}</div>
                                <div class="row-icon user"
                                     *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                                     [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                                  <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                                    "enterprise_contract.panel_document.table_users.representative_inactive" | translate
                                  }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span>
                                </div>
                                <div class="row-icon disabled user"
                                     *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                                  {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                                </div>
                                <hr style="margin: 0; padding: 0" />
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixUserInput>
                            <nz-spin *ngIf="nzCheckLoadingUserSign" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                          style="font-size: 24px"></i></ng-template>
                        </div>
                      </div>
                      <div class="head-table border-top-right-left" style="width: 10%;">
                      </div>
                    </div>
                    <!-- Danh sách ký duyệt duyệt  -->
                    <div class="col-12 p-table-base font-color-blue border-top-right-left">
                      {{ "form.user_signs_and_approves_the_contract" | translate}} &nbsp;
                    </div>
                    <ng-container *ngFor="let user of userSigns; let j = index">
                      <ng-container *ngIf="user.role == '1'" >
                        <div class="row" style="margin: 0;">
                          <div class="head-table border-top-left" style="width: 20%;">
                              <div class="d-flex justify-content-center">
                                1
                              </div>
                          </div>
                          <div class="head-table name-left border-top-left" style="width: 50%; word-break: break-all;">
                            <div class="editable-cell" *ngIf="user.userId != null">
                              <div *ngIf="user.departmentName" class="row-icon department"><span
                                class="material-icons">apartment</span>{{ user.departmentName }}</div>
                              <div class="row-icon"><span class="material-icons" *ngIf="!user.departmentName">person</span>
                                {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span></div>
                            </div>
                          </div>
                          <div class="head-table border-top-right-left" style="width: 30%;">
                            <!-- Nút resize  -->
                            <button color="primary" mat-icon-button (click)="onClickResize(j, enterprise.isCreatedSide)"
                                    type="button">
                              <span *ngIf="user.signConfig.resize">
                                <img src="assets/images/drag_pan.svg"
                                    matTooltip="{{ 'enterprise_contract.tooltips.off_change_size_and_position' | translate }}"
                                    style="width: 22px; height: 22px;margin-bottom: 3px">
                              </span>
                              <span *ngIf="!user.signConfig.resize">
                                <img src="assets/images/drag_pan-1.svg"
                                    matTooltip="{{ 'enterprise_contract.tooltips.on_change_size_and_position' | translate }}"
                                    style="width: 22px; height: 22px;margin-bottom: 3px">
                              </span>
                            </button>
                            <!-- Nút thêm chân ký  -->
                            <button (click)="addSign(user)" color="primary" mat-icon-button
                              type="button">
                              <mat-icon class="mr-0" matTooltip="{{
                                'enterprise_contract.tooltips.add_sign' | translate
                              }}">add_circle
                              </mat-icon>
                            </button>
                            <!-- Nút xóa  -->
                            <ng-container *ngIf="!selectedServiceType?.internalFlowNotEdit">
                              <a *ngIf="user.userId != null" nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                                  'popup.confirm_delete_party' | translate
                                }}" (nzOnConfirm)="deleteUser(user)"
                                nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}" class="delete-icon">
                                <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                              </a>
                              <ng-template #iconDel>
                                <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                              </ng-template>
                            </ng-container>
                            <ng-container *ngIf="selectedServiceType?.internalFlowNotEdit">
                              <a *ngIf="user.userId != null" class="delete-icon"
                              >
                                <i class="fa fa-trash disable-delete" aria-hidden="true"></i>
                              </a>
                            </ng-container>
                          </div>
                        </div>
                        <div *ngFor="let sign of listSign; let id = index">
                          <div class="row" style="margin: 0;" *ngIf="sign.userId == user.userId && checkHaveSign(user, sign)">
                            <div class="head-table border-top-left" style="width: 20%;">
                            </div>
                            <div class="head-table name-left border-top-left" style="width: 50%;">
                              {{ "signature_number" | translate }} {{sign.row_number}} (trang {{sign.pageIndex}})
                            </div>
                            <div class="head-table border-top-right-left" style="width: 30%;">
                              <button (click)="goToPage(user.enterpriseId, user.userId, sign,(user.customerId || null))"
                                color="primary" mat-icon-button type="button">
                                <mat-icon class="mr-0" matTooltip="{{
                                  'enterprise_contract.tooltips.go_to_sign' | translate
                                }}">double_arrow
                                </mat-icon>
                              </button>
                              <button (click)="deleteSign(user.enterpriseId, user.userId, (sign.contractSignId || sign.idNumber) ,(user.customerId || null))"
                                color="primary" mat-icon-button type="button">
                                <mat-icon class="mr-0" matTooltip="{{
                                  'enterprise_contract.tooltips.delete_sign' | translate
                                }}">close
                                </mat-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </ng-container>
                    <!-- Tìm kiếm danh sách ký duyệt  -->
                    <div class="row" style="margin: 0;" *ngIf="isShowSearchUserSign">
                      <div class="head-table border-top-left" style="width: 20%;">
                      </div>
                      <div class="head-table border-top-left" style="width: 70%;">
                        <div style="width: 100%;">
                          <nz-input-group [nzSuffix]="suffixUserInput">
                            <input [disabled]="warningContractQuantity || selectedServiceType?.internalFlowNotEdit" nz-input [(ngModel)]="inputUserSignValue"
                                   (input)="onChangeUserSearch($event)" [nzAutocomplete]="autoUserSignSearching"
                                   [ngModelOptions]="{ standalone: true }"
                                   placeholder="{{ 'placeholder.name_email_and_posiotion' | translate }}" #autocompleteInput
                                   id="inputUserSign" />
                            <nz-autocomplete #autoUserSignSearching>
                              <nz-auto-option *ngFor="let user of filteredUserOptions"
                                              (selectionChange)="autocompleteUserSignSelected($event, user)" [nzValue]="''">
                                <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department"><span
                                  class="material-icons">apartment</span>{{ user.departmentName }}</div>
                                <div class="row-icon user"
                                     *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                                     [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                                  <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{user.name}} <span *ngIf="user.email">- {{user.email}}</span> <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{
                                    "enterprise_contract.panel_document.table_users.representative_inactive" | translate
                                  }}</span> <span *ngIf="user.userPosition"> - {{user.userPosition}}</span>
                                </div>
                                <div class="row-icon disabled user"
                                     *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                                  {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                                </div>
                                <hr style="margin: 0; padding: 0" />
                              </nz-auto-option>
                            </nz-autocomplete>
                          </nz-input-group>
                          <ng-template #suffixUserInput>
                            <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
                          </ng-template>
                          <ng-template #indicatorUserInput><i class="nz-icon-font" nz-icon nzType="loading"
                          style="font-size: 24px"></i></ng-template>
                        </div>
                      </div>
                      <div class="head-table border-top-right-left" style="width: 10%;">
                      </div>
                    </div>
                    <mat-error class="font-weight-bold  border-top-right-left error-message-signer" *ngIf="isNoSigner">
                      {{ "validation.error_user_no_set_up" | translate }}
                    </mat-error>
                  </div>
                </div>
              </ng-container>
            </div>
            <!-- Thêm bên lập -->
            <div class="row p-table-base border-top-right-left font-color-blue" style="font-weight: 600; align-items: center;" *ngIf="!enterpriseSign.length">
              {{ "form.add_create_sign" | translate }}
              <mat-icon class="ml-0 text-primary" style="font-size: x-large; cursor: pointer; margin-left: 8px !important;"
                        matTooltip="{{ 'form.add_create_sign' | translate }}" (click)="addEnterprise(true)">
                add_circle_outline
              </mat-icon>
            </div>
            <!-- Nếu là khách hàng  -->
            <form [formGroup]="form">
              <div formArrayName="enterprises">
                <div *ngFor="let enterprise of enterprises.controls; let i = index" [formGroupName]="i">
                  <ng-container>
                    <div class="row border-top-right-left" style="padding: 16px 8px; font-weight: 700;" *ngIf="enterprise.get('name').value && enterprise.get('name').value.length > 0">
                      {{enterprise.get('name').value}}
                    </div>
                    <div class="row border-top-right-left" style="padding: 16px 8px;" *ngIf="!(enterprise.get('name').value && enterprise.get('name').value.length > 0)">
                      {{ "form.info_party_sign" | translate }} {{enterprise.get('order').value}}
                    </div>
                    <div class="row">
                        <div class="col-2 head-table border-top-left" style="align-items: start;">
                          <nz-input-number class="td-nz-input" [nzMin]="1"
                            formControlName="order">
                          </nz-input-number>
                        </div>
                        <div class="col-7 head-table border-top-left">
                          <div style="width: 100%;">
                            <div class="mb-3">
                              <nz-input-group [nzSuffix]="suffixPartyInput">
                                <input nz-input formControlName="inputPartyValue"
                                        (input)="onChangePartySignSearch($event, i)" [nzAutocomplete]="autoPartySearching"
                                        placeholder="{{ 'placeholder.input_paperNumber_quickly' | translate }}" #autocompleteInput
                                        id="inputParty_{{ i }}" style="text-align: left;"/>
                                <nz-autocomplete #autoPartySearching>
                                  <nz-auto-option *ngFor="let party of filteredPartyOptions"
                                    (selectionChange)="autocompletePartySelected($event, party, i)" [nzValue]="''">
                                    <div class="d-flex">
                                      <mat-icon class="mr-2">account_circle</mat-icon>
                                      <span style="line-height: 20px">
                                          {{ party.name }} -
                                        {{
                                          party.taxCode && party.taxCode.length > 0
                                            ? party.taxCode
                                            : party.certificateNo
                                        }}
                                        </span>
                                    </div>
                                    <div class="d-flex">
                                      <mat-icon class="mr-2">contact_mail</mat-icon>
                                      <span style="line-height: 20px">
                                          <span *ngIf="party.email">{{ party.email }} -</span>
                                        {{ party.phone }}
                                        </span>
                                    </div>
                                    <hr style="margin: 0; padding: 0" />
                                  </nz-auto-option>
                                </nz-autocomplete>
                              </nz-input-group>
                              <ng-template #suffixPartyInput>
                                <nz-spin *ngIf="enterprise.get('isLoading').value" nzSimple [nzIndicator]="indicatorPartyInput"></nz-spin>
                              </ng-template>
                              <ng-template #indicatorPartyInput><i class="nz-icon-font" nz-icon nzType="loading"
                              style="font-size: 24px"></i></ng-template>
                              </div>
                            <div style="display: flex; flex-direction: column; justify-content: space-between;">
                              <div style="width: 100%;">
                                  <input nz-input formControlName="certificateNo"
                                    (input)="onChangeCertificateNo($event)"
                                    placeholder="{{ 'placeholder.taxCode' | translate }}"
                                    required
                                    maxlength="20"
                                    [ngClass]="enterprise.get('certificateNo')?.invalid && enterprise.get('certificateNo')?.touched ? 'error-input' : ''"
                                  />
                              </div>
                              <div *ngIf="enterprise.get('certificateNo')?.invalid && enterprise.get('certificateNo')?.errors?.required && enterprise.get('certificateNo')?.touched" class="text-error mb-1">
                                {{ 'messages.certificate_required' | translate }}
                              </div>
                              <div *ngIf="enterprise.get('certificateNo')?.invalid && enterprise.get('certificateNo')?.errors?.pattern && enterprise.get('certificateNo')?.touched" class="text-error mb-1">
                                {{ 'update_enterprise.validation.lbl_validation_gpkd_format' | translate }}
                              </div>
                              <div style="display: flex; flex-direction: row; justify-content: start; align-items: center; width: 100%; height: 50px;">
                                <nz-radio-group formControlName="customerType" style="display: flex;">
                                  <label nz-radio nzValue="10000">{{ 'lading_page.main.package.personal' | translate }}</label>
                                  <label nz-radio nzValue="10001">{{ 'lading_page.main.package.organization' | translate }}</label>
                                </nz-radio-group>
                              </div>
                            </div>
                            <div class="mb-3">
                              <input nz-input
                              formControlName="name"
                              placeholder="{{ 'placeholder.enter_name' | translate }}"
                              required
                              maxlength="200"
                              [ngClass]="enterprise.get('name')?.invalid && enterprise.get('name')?.touched ? 'error-input' : ''"
                              />
                              <div *ngIf="enterprise.get('name')?.invalid && enterprise.get('name')?.touched" class="text-error">
                                {{ 'messages.customer_name_required' | translate }}
                              </div>
                            </div>
                            <div class="mb-3">
                              <input nz-input formControlName="email"
                                placeholder="{{ 'placeholder.enter_mail' | translate }}"
                                [ngClass]="enterprise.get('email')?.invalid && enterprise.get('email')?.touched ? 'error-input' : ''"
                                maxlength="100"
                              />
                              <div *ngIf="enterprise.get('email')?.invalid && enterprise.get('email')?.touched" class="text-error">
                                {{ 'messages.email_invalid' | translate }}
                              </div>
                            </div>
                            <div>
                              <input nz-input formControlName="phone"
                              placeholder="{{ 'placeholder.enter_phone' | translate }}"
                              required
                              [maxlength]="maxLengthPhone"
                              [ngClass]="enterprise.get('phone')?.invalid && enterprise.get('phone')?.touched ? 'error-input' : ''"
                              />
                              <div *ngIf="enterprise.get('phone')?.invalid && enterprise.get('phone')?.errors?.required && enterprise.get('phone')?.touched" class="text-error">
                                {{ 'messages.phone_number_required' | translate }}
                              </div>
                              <div *ngIf="enterprise.get('phone')?.invalid && enterprise.get('phone')?.errors?.pattern && enterprise.get('phone')?.touched" class="text-error">
                                {{ 'validation.phone_format_upgrade' | translate }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="col-3 head-table border-top-right-left" style="align-items: start;">
                          <!-- Nút resize  -->
                          <button color="primary" mat-icon-button (click)="onClickResize(i, enterprise.isCreatedSide)"
                                  type="button">
                            <span *ngIf="enterprises.at(i).get('resize').value">
                              <img src="assets/images/drag_pan.svg"
                                  matTooltip="{{ 'enterprise_contract.tooltips.off_change_size_and_position' | translate }}"
                                  style="width: 22px; height: 22px;margin-bottom: 3px">
                            </span>
                            <span *ngIf="!enterprises.at(i).get('resize').value">
                              <img src="assets/images/drag_pan-1.svg"
                                  matTooltip="{{ 'enterprise_contract.tooltips.on_change_size_and_position' | translate }}"
                                  style="width: 22px; height: 22px;margin-bottom: 3px">
                            </span>
                          </button>
                          <!-- Nút thêm chân ký  -->
                          <button (click)="addSign(enterprise,i)" color="primary" mat-icon-button
                            type="button" [disabled]="enterprises.at(i).invalid">
                            <mat-icon class="mr-0" matTooltip="{{
                              'enterprise_contract.tooltips.add_sign' | translate
                            }}">add_circle
                            </mat-icon>
                          </button>
                          <!-- Nút xóa  -->
                          <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                              'popup.confirm_delete_party' | translate
                            }}" (nzOnConfirm)="deleteEnterprise(enterprise, false, i)"
                            nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}" class="delete-icon">
                            <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                          </a>
                          <ng-template #iconDel>
                            <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                          </ng-template>
                        </div>
                    </div>
                    <div *ngFor="let sign of listSign; let id = index">
                      <div class="row" *ngIf="checkHaveSignCustomer(enterprise, sign)">
                        <div class="col-2 head-table border-top-left">
                        </div>
                        <div class="col-7 head-table name-left border-top-left">
                          {{ "signature_number" | translate }} {{sign.row_number}} (trang {{sign.pageIndex}})
                        </div>
                        <div class="col-3 head-table border-top-right-left">
                          <button (click)="goToPageCustomer(i, sign)"
                            color="primary" mat-icon-button type="button">
                            <mat-icon class="mr-0" matTooltip="{{
                              'enterprise_contract.tooltips.go_to_sign' | translate
                            }}">double_arrow
                            </mat-icon>
                          </button>
                          <button (click)="deleteSignCustomer(enterprise, sign)"
                            color="primary" mat-icon-button type="button">
                            <mat-icon class="mr-0" matTooltip="{{
                              'enterprise_contract.tooltips.delete_sign' | translate
                            }}">close
                            </mat-icon>
                          </button>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </form>
            <!-- Thêm bên ký -->
            <div class="row p-table-base border-top font-color-blue" style="font-weight: 600; align-items: center;">
              <mat-icon class="ml-0 text-primary" style="font-size: x-large; cursor: pointer; margin-right: 8px;"
                        matTooltip="{{ 'form.add_enterprise' | translate }}" (click)="addEnterprise(false)">
                add_circle_outline
              </mat-icon>
              {{ "form.add_enterprise" | translate }}
            </div>
            <mat-error class="font-weight-bold" *ngIf="isInvalidSetPartyFlow">
              {{ "validation.error_enterprise_no_set_up" | translate }}
            </mat-error>
          </mat-expansion-panel>
      </div>

      <!-- View file  -->
      <div [ngClass]="{
          'col-lg-7 pl-0': tabMode !== 'hide',
          'col-lg-12': tabMode === 'hide'
        }" class="col-lg-7 col-md-12 col-sm-12" style="padding-right: 0.75rem">

        <div [ngStyle]="{
          'background-color':
          fileUploads.length ? '#a6a6a6' : '#fff'
        }" class="text-left mat-elevation-z0 d-flex justify-content-between align-items-center">
        <div [ngStyle]="{
            'border-bottom-right-radius': activeFile === 0 ? '5px' : '0'
          }" class="pl-3 py-2 box-left">
          <button (click)="tabMode = 'hide'" *ngIf="tabMode !== 'hide'" [matTooltip]="
              'enterprise_contract.tooltips.btn_expand_more' | translate
            " class="mr-2 custom-button-icon" color="primary" mat-stroked-button type="button">
            <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">fullscreen</mat-icon>
          </button>
          <button (click)="tabMode = 'info'" *ngIf="tabMode === 'hide'"
            [matTooltip]="'enterprise_contract.tooltips.info_tab' | translate" class="mr-2 custom-button-icon"
            color="primary" mat-stroked-button type="button">
            <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">info</mat-icon>
          </button>
        </div>
        <div [ngStyle]="{
            background: fileUploads.length
              ? 'linear-gradient(180deg, #fff 70%, #a6a6a6 30%)'
              : '#fff'
          }" class="tab-file">
          <div style="width: 100%; position: relative; height: 52px;">
            <div class="d-flex box-tab" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)"
              style="position: absolute; width: 100%; top: 0.5rem; left: 0; height: calc(52px - 0.5rem);">
              <div (click)="changeFile(file.path, i)" cdkDrag
                *ngFor="let file of mainContractAttachments; let i = index" [class.active]="i === activeFile"
                [class.border-right]="i !== fileUploads.length - 1 && i !== activeFile && i !== activeFile - 1"
                [class.left]="i === activeFile - 1" [class.right]="i === activeFile + 1" [matTooltip]="file.fileName + ' (' + (file.fileSize/1024/1024).toFixed(2) + 'mb)'"
                class="pl-2 py-2 tab d-flex">
                <div class="name">
                  {{ file.fileName }}
                </div>
                <a (click)="removeFile(i)"><span class="material-icons"> close </span></a>
              </div>
            </div>
          </div>
        </div>
        <div [ngStyle]="{
            'border-bottom-left-radius':
              activeFile === fileUploads.length - 1 ? '5px' : '0'
          }" class="d-flex pr-3 py-2 box-right">
          <!-- Chọn tệp từ máy -->
          <div class="ml-2">
            <button #btnUpload (click)="chooseFile()"
              [matTooltip]="'button.choose_a_file' | translate"
              class="mr-2 mat-stroked-button-create-document custom-button-icon" color="primary" id="btnUpload"
              mat-raised-button type="button">
              <mat-icon class="mr-0">cloud_upload</mat-icon>
            </button>
            <input #inputUpload (change)="onSelectedUpload($event)" accept="application/pdf"
              class="form-control-file vt-input-form d-none mat-stroked-button-create-document" id="file" multiple
              name="file" type="file" />
          </div>
        </div>
      </div>
      <div #navigation class="document" id="pdfContainer" style="height: calc(91vh - 140px)">
        <ng-container *ngIf="pdfSrc && !isHide; else notUpload">
          <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
          (textLayerRendered)="textLayerRendered($event)" [(page)]="pageIndex" [enablePrint]="false"
          [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
          [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
          [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
          [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
          class="pdf-viewer" height="calc(85vh - 140px)" style="display: block" useBrowserLocale="true"
          [httpHeaders]="authorization">
          </ngx-extended-pdf-viewer>
        </ng-container>

        <!-- No file -->
        <div style="display: flex; justify-content: center; align-items: center">
          <ng-template #notUpload>
            <div *ngIf="!pdfSrc && !isHide" class="container">
              <div class="drd-container">
                <input #inputUpload1 (change)="onSelectedUpload($event)" accept="application/pdf"
                  class="form-control-file vt-input-form d-none" id="file" multiple name="file" style="cursor: pointer"
                  type="file" />
                <br />
                <button #btnUpload1 (click)="inputUpload.click()"
                  class="mr-2 mat-stroked-button-create-document" color="primary" id="btnUpload1" mat-stroked-button
                  type="button">
                  <mat-icon class="mr-0">cloud_upload</mat-icon>
                  {{ "button.choose_a_file" | translate }}
                </button>

                <h5 style="margin-top: 2em">
                  ({{ mesage }})
                </h5>
                <br /><br />
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      </div>

      <!-- Button save  -->
      <div
          class="bg-white text-center mat-elevation-z0 py-2 w-100"
          id="navigation"
          #navigation
          style="border-top: 1px solid #0000001f;position: sticky;bottom: 0;display: flex;align-items: center;justify-content: center;padding-right: 11rem;z-index: 1;"
      >
          <button
          id="btn-cancel"
          mat-stroked-button
          color="primary"
          class="mr-3"
          type="button"
          (click)="onClickBtnCancel()"
          >
          <mat-icon class="mr-0">cancel</mat-icon>
          {{ "button.cancel" | translate }}
          </button>

          <button
          mat-stroked-button
          (click)="onClickBtnSave(true)"
          class="mr-3"
          type="submit"
          color="primary"
          >
          <mat-icon class="mr-0">save</mat-icon>
          <ng-container>
              {{ "button.save_draft" | translate }}
          </ng-container>
          </button>

          <button mat-raised-button color="primary" class="btn mr-3" (click)="onClickBtnSave(false)">
          <mat-icon class="mr-0">send</mat-icon>
          {{ "enterprise_contract.buttons.start_flow" | translate }}
          </button>
      </div>
  </div>